import { render, staticRenderFns } from "./UserAccountCompanyPolicies.vue?vue&type=template&id=59418581&"
import script from "./UserAccountCompanyPolicies.vue?vue&type=script&lang=js&"
export * from "./UserAccountCompanyPolicies.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountCompanyPolicies.vue?vue&type=style&index=0&id=59418581&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports